import { gql } from "@apollo/client";

export const DELETE_STAFF = gql`
  mutation deleteVenueStaff($venueStaffId: Int!) {
    deleteVenueStaff(venueStaffId: $venueStaffId) {
      id
    }
  }
`;
